import _toConsumableArray from "/Users/perryazevedo/Projects/somn/somn-web/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "/Users/perryazevedo/Projects/somn/somn-web/node_modules/react-scripts/node_modules/@babel/runtime/regenerator";
import _defineProperty from "/Users/perryazevedo/Projects/somn/somn-web/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/Users/perryazevedo/Projects/somn/somn-web/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import 'regenerator-runtime/runtime';
import * as firebase from '@firebase/app';
import * as firebasedb from '@firebase/database';
import * as firebasestore from '@firebase/storage';
import validate from 'validate.js';
import compose from 'compose-then';
import values from 'lodash/values';
import keys from 'lodash/keys';
import find from 'lodash/find';
import _get from 'lodash/get';
import set from 'lodash/set';
import isArray from 'lodash/isArray';
import pick from 'lodash/fp/pick';
import resizeImage from 'browser-image-resizer';
import './polyfills';
import error from './utils/error';
import deprecate from './utils/deprecate';
import { applyOrderBy, applyFilters, getContentRefPath, getNavigationRefPath, getSchemasRefPath, getStorageRefPath, getSettingsRefPath, getFileRefPath, getFolderRefPath, getMediaRefPath, pluckResultFields, populateEntry, filterByFolderId, formatStructure, getScreenResolution, hasNonCacheableOptions, prepConstraintsForValidate } from './utils';
import { DEFAULT_CONFIG, ALLOWED_CHILD_EVENTS, DEFAULT_REQUIRED_IMAGE_SIZE } from './constants';
var CACHE = {};

function flamelink() {
  var conf = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var firebaseApp_ = null;
  var databaseService_ = null;
  var storageService_ = null;
  var authService_ = null;
  var firestoreService_ = null;
  var isAdminApp_ = false;
  var config = Object.assign({}, DEFAULT_CONFIG, conf); // Set flamelink specific properties

  var env_ = config.env;
  var locale_ = config.locale; // Init firebaseApp if not set or provided

  if (config.firebaseApp) {
    firebaseApp_ = config.firebaseApp; // Is the Firebase app instance an admin app instance?

    if (config.isAdminApp) {
      isAdminApp_ = true;
    }
  } else if (!firebaseApp_) {
    var apiKey = config.apiKey,
        authDomain = config.authDomain,
        databaseURL = config.databaseURL,
        storageBucket = config.storageBucket,
        projectId = config.projectId;

    if (!apiKey || !authDomain || !databaseURL || !projectId) {
      throw error('The following config properties are mandatory: "apiKey", "authDomain", "databaseURL", "projectId"');
    }

    firebaseApp_ = firebase.initializeApp({
      apiKey: apiKey,
      authDomain: authDomain,
      databaseURL: databaseURL,
      storageBucket: storageBucket,
      projectId: projectId
    }, projectId);
  }

  var getService = function getService(service, serviceName) {
    return service || typeof firebaseApp_[serviceName] === 'function' ? firebaseApp_[serviceName]() : null;
  };

  databaseService_ = getService(databaseService_, 'database');
  storageService_ = getService(storageService_, 'storage');
  authService_ = getService(authService_, 'auth');
  firestoreService_ = getService(firestoreService_, 'firestore');
  var schemasAPI = {
    /**
     * Establish and return a reference to schemas in firebase db
     *
     * @param {String} schemaRef
     * @returns {Object} Ref object
     */
    ref: function ref(schemaRef) {
      if (!databaseService_) {
        throw error('The Database service is not available. Make sure the "databaseURL" property is provided.');
      }

      return databaseService_.ref(getSchemasRefPath(schemaRef || null, env_, locale_));
    },

    /**
     * Read all or an individual schema from the db and return snapshot response
     *
     * @param {String} [schemaRef] The schema's key in the db
     * @param {Object} [options={}]
     * @returns {Promise} Resolves to snapshot of query
     */
    getRaw: function getRaw(schemaRef) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var ref = typeof schemaRef === 'string' ? schemaRef : null;
      var opts = typeof schemaRef === 'string' ? options : schemaRef || {};
      var ordered = applyOrderBy(schemasAPI.ref(ref), opts);
      var filtered = applyFilters(ordered, opts);
      return filtered.once(opts.event || 'value');
    },

    /**
     * Get all schemas or an individual schema object for the given reference
     *
     * @param {String} schemaRef The schema's key in the db
     * @param {Object} [options={}]
     * @returns {Promise} Resolves to value of query
     */
    get: function () {
      var _get2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(schemaRef) {
        var options,
            _pluckFields,
            schema,
            snapshot,
            wrapValue,
            schemas,
            _snapshot,
            pluckFields,
            _args = arguments;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};

                if (!(typeof schemaRef === 'string')) {
                  _context.next = 11;
                  break;
                }

                // Single Schema
                _pluckFields = pluckResultFields(options.fields);
                schema = _get(CACHE, "schemas[".concat(env_, "].").concat(schemaRef));

                if (!(!schema || hasNonCacheableOptions(options))) {
                  _context.next = 9;
                  break;
                }

                _context.next = 7;
                return schemasAPI.getRaw(schemaRef, options);

              case 7:
                snapshot = _context.sent;
                schema = snapshot.val();

              case 9:
                wrapValue = _defineProperty({}, schemaRef, schema); // Wrapping value to create the correct structure for our filtering to work

                return _context.abrupt("return", _pluckFields(wrapValue)[schemaRef]);

              case 11:
                // All Schemas
                options = schemaRef || {};
                schemas = _get(CACHE, "schemas[".concat(env_, "]"));

                if (!(!schemas || hasNonCacheableOptions(options))) {
                  _context.next = 18;
                  break;
                }

                _context.next = 16;
                return schemasAPI.getRaw(null, options);

              case 16:
                _snapshot = _context.sent;
                schemas = _snapshot.val();

              case 18:
                pluckFields = pluckResultFields(options.fields);
                return _context.abrupt("return", pluckFields(schemas));

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function get(_x) {
        return _get2.apply(this, arguments);
      }

      return get;
    }(),

    /**
     * Get all schemas' or an individual schema's fields and return snapshot response
     *
     * @param {String} schemaRef
     * @param {Object} [options={}]
     * @returns {Promise} Resolves to snapshot of query
     */
    getFieldsRaw: function getFieldsRaw(schemaRef) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var ref = typeof schemaRef === 'string' ? "".concat(schemaRef, "/fields") : null;
      var opts = typeof schemaRef === 'string' ? options : schemaRef || {};
      var ordered = applyOrderBy(schemasAPI.ref(ref), opts);
      var filtered = applyFilters(ordered, opts);
      return filtered.once(opts.event || 'value');
    },

    /**
     * Get all schemas' or an individual schema's fields array for the given reference
     *
     * @param {String} schemaRef
     * @param {Object} [options={}]
     * @returns {Promise} Resolves to value of query
     */
    getFields: function () {
      var _getFields = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(schemaRef) {
        var options,
            schemaCache,
            fields,
            snapshot,
            opts,
            schemas,
            _snapshot2,
            _args2 = arguments;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                options = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};

                if (!(typeof schemaRef === 'string')) {
                  _context2.next = 10;
                  break;
                }

                // Single schema
                schemaCache = _get(CACHE, "schemas[".concat(env_, "].").concat(schemaRef));
                fields = schemaCache ? schemaCache.fields : null;

                if (!(!fields || hasNonCacheableOptions(options))) {
                  _context2.next = 9;
                  break;
                }

                _context2.next = 7;
                return schemasAPI.getFieldsRaw(schemaRef, options);

              case 7:
                snapshot = _context2.sent;
                fields = snapshot.val();

              case 9:
                return _context2.abrupt("return", pluckResultFields(options.fields, fields));

              case 10:
                // All schemas
                opts = schemaRef || {};
                schemas = _get(CACHE, "schemas[".concat(env_, "]"));

                if (!(!schemas || hasNonCacheableOptions(opts))) {
                  _context2.next = 17;
                  break;
                }

                _context2.next = 15;
                return schemasAPI.getFieldsRaw(opts);

              case 15:
                _snapshot2 = _context2.sent;
                schemas = _snapshot2.val();

              case 17:
                return _context2.abrupt("return", keys(schemas).reduce(function (result, key) {
                  return Object.assign({}, result, _defineProperty({}, key, pluckResultFields(opts.fields, schemas[key].fields)));
                }, {}));

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function getFields(_x2) {
        return _getFields.apply(this, arguments);
      }

      return getFields;
    }(),

    /**
     * @description Establish stream to read value consistently from db, returning the raw snapshot
     * @param {String} [schemaKey]
     * @param {Object} [options={}]
     * @param {Function} cb
     * @returns {Promise} Resolves to snapshot of query
     */
    subscribeRaw: function subscribeRaw(schemaKey) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var cb = arguments.length > 2 ? arguments[2] : undefined;

      // Single schema
      if (typeof schemaKey === 'string') {
        if (!cb) {
          cb = options; // second param is then the callback

          options = {}; // set default options
        }

        var _ordered = applyOrderBy(schemasAPI.ref(schemaKey), options);

        var _filtered = applyFilters(_ordered, options);

        return _filtered.on(options.event || 'value', cb);
      } // All schemas


      cb = options;
      options = schemaKey || {};

      if (typeof cb === 'object') {
        cb = schemaKey; // first param is then the callback

        options = {}; // set default options
      }

      var ordered = applyOrderBy(schemasAPI.ref(null), options);
      var filtered = applyFilters(ordered, options);
      return filtered.on(options.event || 'value', cb);
    },

    /**
     * @description Establish stream to read value consistently from db, returning the processed value
     * @param {String} [schemaKey]
     * @param {Object} [options={}]
     * @param {Function} cb
     * @returns {Promise} Resolves to value of query
     */
    subscribe: function subscribe(schemaKey) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var cb = arguments.length > 2 ? arguments[2] : undefined;

      try {
        // Single schema
        if (typeof schemaKey === 'string') {
          if (!cb || typeof options === 'function') {
            cb = options; // second param is then the callback

            options = {}; // set default options
          }

          var _pluckFields2 = pluckResultFields(options.fields);

          return schemasAPI.subscribeRaw(schemaKey, options,
          /*#__PURE__*/
          function () {
            var _ref = _asyncToGenerator(
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee3(snapshot) {
              var wrappedSchema, schema;
              return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                  switch (_context3.prev = _context3.next) {
                    case 0:
                      _context3.next = 2;
                      return compose(_pluckFields2)(_defineProperty({}, schemaKey, snapshot.val()));

                    case 2:
                      wrappedSchema = _context3.sent;
                      schema = wrappedSchema[schemaKey];
                      return _context3.abrupt("return", cb(null, schema));

                    case 5:
                    case "end":
                      return _context3.stop();
                  }
                }
              }, _callee3);
            }));

            return function (_x3) {
              return _ref.apply(this, arguments);
            };
          }());
        } // All schemas


        cb = options;
        options = schemaKey || {};

        if (typeof cb === 'object') {
          cb = schemaKey; // first param is then the callback

          options = {}; // set default options
        }

        var pluckFields = pluckResultFields(options.fields);
        return schemasAPI.subscribeRaw(options,
        /*#__PURE__*/
        function () {
          var _ref2 = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee4(snapshot) {
            var pluckedSchemas;
            return _regeneratorRuntime.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    _context4.next = 2;
                    return compose(pluckFields)(snapshot.val());

                  case 2:
                    pluckedSchemas = _context4.sent;
                    cb(null, pluckedSchemas); // Error-first callback

                  case 4:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4);
          }));

          return function (_x4) {
            return _ref2.apply(this, arguments);
          };
        }());
      } catch (err) {
        return cb(err);
      }
    },

    /**
     * @description Detach listeners from given reference.
     * @param {String} schemaKey
     * @param {String} event
     * @returns {Promise}
     */
    unsubscribe: function unsubscribe() {
      if (arguments.length === 2) {
        // Is second arg a valid firebase child event?
        if (ALLOWED_CHILD_EVENTS.includes(arguments.length <= 1 ? undefined : arguments[1])) {
          // args[0] = schemaKey
          // args[1] = event
          return schemasAPI.ref(arguments.length <= 0 ? undefined : arguments[0]).off(arguments.length <= 1 ? undefined : arguments[1]);
        }

        throw error("\"".concat(arguments.length <= 1 ? undefined : arguments[1], "\" is not a valid child event"));
      }

      if (arguments.length === 1) {
        return schemasAPI.ref(arguments.length <= 0 ? undefined : arguments[0]).off();
      }

      throw error('"unsubscribe" method needs to be called with min 1 argument and max 2 arguments');
    },

    /**
     * @description Save data for a specific schema.
     * This overwrites data at the specified location, including any child nodes.
     * @param {String} schemaKey
     * @param {Object} payload
     * @returns {Promise}
     */
    set: function set(schemaKey, payload) {
      if (typeof schemaKey !== 'string' || typeof payload !== 'object' && payload !== null) {
        throw error('"set" called with the incorrect arguments. Check the docs for details.');
      }

      var payload_ = typeof payload === 'object' ? Object.assign({}, payload, {
        __meta__: {
          createdBy: _get(authService_, 'currentUser.uid', 'UNKNOWN'),
          createdDate: new Date().toISOString()
        },
        id: schemaKey
      }) : payload;
      return schemasAPI.ref(schemaKey).set(payload_);
    },

    /**
     * @description Simultaneously write to specific children of a node without overwriting other child nodes.
     * @param {String} schemaKey
     * @param {Object} payload
     * @returns {Promise}
     */
    update: function update(schemaKey, payload) {
      if (typeof schemaKey === 'number') {
        schemaKey = schemaKey.toString();
      }

      if (typeof schemaKey !== 'string' || typeof payload !== 'object' && payload !== null) {
        throw error('"update" called with the incorrect arguments. Check the docs for details.');
      }

      var payload_ = typeof payload === 'object' ? Object.assign({}, payload, {
        '__meta__/lastModifiedBy': _get(authService_, 'currentUser.uid', 'UNKNOWN'),
        '__meta__/lastModifiedDate': new Date().toISOString(),
        id: schemaKey
      }) : payload;
      return schemasAPI.ref(schemaKey).update(payload_);
    },

    /**
     * @description The simplest way to delete a schema.
     * @param {String} schemaKey
     * @returns {Promise}
     */
    remove: function remove(schemaKey) {
      if (typeof schemaKey === 'number') {
        schemaKey = schemaKey.toString();
      }

      if (typeof schemaKey !== 'string') {
        throw error('"remove" called with the incorrect arguments. Check the docs for details.');
      }

      return schemasAPI.ref(schemaKey).remove();
    },

    /**
     * @description Transactional operation
     * https://firebase.google.com/docs/reference/js/firebase.database.Reference#transaction
     * @param {String} schemaKey
     * @param {Function} updateFn
     * @param {Function} [cb=() => {}]
     * @returns
     */
    transaction: function transaction(schemaKey, updateFn) {
      var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

      if (typeof schemaKey === 'number') {
        schemaKey = schemaKey.toString();
      }

      if (typeof schemaKey !== 'string' || typeof updateFn !== 'function') {
        throw error('"transaction" called with the incorrect arguments. Check the docs for details.');
      }

      return schemasAPI.ref(schemaKey).transaction(updateFn, cb);
    }
  };
  var settingsAPI = {
    /**
     * Establish and return a reference to section in firebase db
     *
     * @param {String} ref
     * @returns {Object} Ref object
     */
    ref: function ref(_ref3) {
      if (!databaseService_) {
        throw error('The Database service is not available. Make sure the "databaseURL" property is provided.');
      }

      return databaseService_.ref(getSettingsRefPath(_ref3));
    },

    /**
     * @description Get snapshot for given settings reference
     * @param {String} settingsRef
     * @param {Object} [options={}]
     * @returns {Promise} Resolves to snapshot of query
     */
    getRaw: function getRaw(settingsRef) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var ref = typeof settingsRef === 'string' ? settingsRef : null;
      var opts = typeof settingsRef === 'string' ? options : settingsRef || {};
      var ordered = applyOrderBy(settingsAPI.ref(ref), opts);
      var filtered = applyFilters(ordered, opts);
      return filtered.once(opts.event || 'value');
    },

    /**
     * Read value once from db
     *
     * @param {String} settingsRef
     * @param {Object} [options={}]
     * @returns {Promise} Resolves to value of query
     */
    get: function () {
      var _get3 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(settingsRef) {
        var options,
            pluckFields,
            snapshot,
            value,
            result,
            _args5 = arguments;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                options = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : {};
                pluckFields = pluckResultFields(options.fields);
                _context5.next = 4;
                return settingsAPI.getRaw(settingsRef, options);

              case 4:
                snapshot = _context5.sent;
                value = options.needsWrap ? _defineProperty({}, settingsRef, snapshot.val()) : snapshot.val();
                _context5.next = 8;
                return compose(pluckFields)(value);

              case 8:
                result = _context5.sent;
                return _context5.abrupt("return", options.needsWrap ? result[settingsRef] : result);

              case 10:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function get(_x5) {
        return _get3.apply(this, arguments);
      }

      return get;
    }(),

    /**
     * Sets the locale to be used for the flamelink app
     *
     * @param {String} locale The locale to set
     * @returns {Promise} Resolves to given locale if it is a supported locale, otherwise it rejects
     */
    setLocale: function () {
      var _setLocale = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6() {
        var locale,
            snapshot,
            supportedLocales_,
            _args6 = arguments;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                locale = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : locale_;
                _context6.next = 3;
                return databaseService_.ref('/flamelink/settings/locales').once('value');

              case 3:
                snapshot = _context6.sent;
                supportedLocales_ = snapshot.val();

                if (supportedLocales_) {
                  _context6.next = 7;
                  break;
                }

                throw error('No supported locales found.');

              case 7:
                if (supportedLocales_.includes(locale)) {
                  _context6.next = 9;
                  break;
                }

                throw error("\"".concat(locale, "\" is not a supported locale. Supported Locales: ").concat(supportedLocales_.join(', ')));

              case 9:
                locale_ = locale;
                return _context6.abrupt("return", locale_);

              case 11:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function setLocale() {
        return _setLocale.apply(this, arguments);
      }

      return setLocale;
    }(),

    /**
     * Returns the set locale for the flamelink app
     *
     * @returns {Promise} Resolves with locale (just using promise for consistency and allowing us to make this async in the future)
     */
    getLocale: function () {
      var _getLocale = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", locale_);

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function getLocale() {
        return _getLocale.apply(this, arguments);
      }

      return getLocale;
    }(),

    /**
     * Sets the environment to be used for the flamelink app
     *
     * @param {String} env The environment to set
     * @returns {Promise} Resolves to given environment if it is a supported environment, otherwise it rejects
     */
    setEnvironment: function () {
      var _setEnvironment = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8() {
        var env,
            snapshot,
            supportedEnvironments_,
            _args8 = arguments;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                env = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : env_;
                _context8.next = 3;
                return databaseService_.ref('/flamelink/settings/environments').once('value');

              case 3:
                snapshot = _context8.sent;
                supportedEnvironments_ = snapshot.val();

                if (supportedEnvironments_) {
                  _context8.next = 7;
                  break;
                }

                throw error("No supported environments found.");

              case 7:
                if (!(isArray(supportedEnvironments_) && !supportedEnvironments_.includes(env) || !isArray(supportedEnvironments_) && !keys(supportedEnvironments_).includes(env))) {
                  _context8.next = 9;
                  break;
                }

                throw error("\"".concat(env, "\" is not a supported environment. Supported Environments: ").concat(supportedEnvironments_.join(', ')));

              case 9:
                env_ = env;
                return _context8.abrupt("return", env_);

              case 11:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      function setEnvironment() {
        return _setEnvironment.apply(this, arguments);
      }

      return setEnvironment;
    }(),

    /**
     * Returns the set environment for the flamelink app
     *
     * @returns {Promise} Resolves with environment (just using promise for consistency and allowing us to make this async in the future)
     */
    getEnvironment: function () {
      var _getEnvironment = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9() {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                return _context9.abrupt("return", env_);

              case 1:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      function getEnvironment() {
        return _getEnvironment.apply(this, arguments);
      }

      return getEnvironment;
    }(),

    /**
     * Returns the set image sizes for the flamelink app
     *
     * @returns {Promise} Resolves with array of image size objects
     */
    getImageSizes: function () {
      var _getImageSizes = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee10() {
        var options,
            _args10 = arguments;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                options = _args10.length > 0 && _args10[0] !== undefined ? _args10[0] : {};
                return _context10.abrupt("return", settingsAPI.get('general/imageSizes', options));

              case 2:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));

      function getImageSizes() {
        return _getImageSizes.apply(this, arguments);
      }

      return getImageSizes;
    }(),

    /**
     * Returns the ID of the default permissions group for the flamelink app
     *
     * @returns {Promise} Resolves with ID of permissions group
     */
    getDefaultPermissionsGroup: function () {
      var _getDefaultPermissionsGroup = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee11() {
        var options,
            _args11 = arguments;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                options = _args11.length > 0 && _args11[0] !== undefined ? _args11[0] : {};
                return _context11.abrupt("return", settingsAPI.get('general/defaultPermissionsGroup', options));

              case 2:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }));

      function getDefaultPermissionsGroup() {
        return _getDefaultPermissionsGroup.apply(this, arguments);
      }

      return getDefaultPermissionsGroup;
    }(),

    /**
     * Returns the global meta data for the flamelink app
     *
     * @returns {Promise} Resolves with globals object
     */
    getGlobals: function () {
      var _getGlobals = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee12() {
        var options,
            _args12 = arguments;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                options = _args12.length > 0 && _args12[0] !== undefined ? _args12[0] : {};
                return _context12.abrupt("return", settingsAPI.get('globals', Object.assign({}, options, {
                  needsWrap: true
                })));

              case 2:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }));

      function getGlobals() {
        return _getGlobals.apply(this, arguments);
      }

      return getGlobals;
    }()
  };
  var storageAPI = {
    /**
     * @description Get the folder ID for a given folder name using an optional fallback folder name
     * @param {string} [folderName='']
     * @param {string} [fallback='Root']
     * @returns {string} folderId
     * @private
     */
    _getFolderId: function () {
      var _getFolderId2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee13() {
        var folderName,
            fallback,
            foldersSnapshot,
            folders,
            folder,
            fallbackFolder,
            _args13 = arguments;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                folderName = _args13.length > 0 && _args13[0] !== undefined ? _args13[0] : '';
                fallback = _args13.length > 1 && _args13[1] !== undefined ? _args13[1] : 'Root';

                if (databaseService_) {
                  _context13.next = 4;
                  break;
                }

                throw error('The Database service is not available. Make sure the "databaseURL" property is provided.');

              case 4:
                _context13.next = 6;
                return databaseService_.ref(getFolderRefPath()).once('value');

              case 6:
                foldersSnapshot = _context13.sent;
                folders = foldersSnapshot.val();
                folder = find(folders, {
                  name: folderName
                });

                if (folder) {
                  _context13.next = 12;
                  break;
                }

                fallbackFolder = find(folders, {
                  name: fallback
                }) || {};
                return _context13.abrupt("return", fallbackFolder.id);

              case 12:
                return _context13.abrupt("return", folder.id);

              case 13:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      }));

      function _getFolderId() {
        return _getFolderId2.apply(this, arguments);
      }

      return _getFolderId;
    }(),

    /**
     * @description Get the folder ID for a given options object. If the ID is given it is simply returned, otherwise it
     * try and deduce it from a given folder name or falling back to the ID for the "Root" directory
     * @param {any} [options={}]
     * @returns {promise} Resolves to the folder ID
     * @private
     */
    _getFolderIdFromOptions: function () {
      var _getFolderIdFromOptions2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee14() {
        var options,
            folderId,
            folderName,
            folderFallback,
            _args14 = arguments;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                options = _args14.length > 0 && _args14[0] !== undefined ? _args14[0] : {};
                folderId = options.folderId, folderName = options.folderName, folderFallback = options.folderFallback;

                if (!folderId) {
                  _context14.next = 4;
                  break;
                }

                return _context14.abrupt("return", folderId);

              case 4:
                return _context14.abrupt("return", storageAPI._getFolderId(folderName, folderFallback));

              case 5:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14);
      }));

      function _getFolderIdFromOptions() {
        return _getFolderIdFromOptions2.apply(this, arguments);
      }

      return _getFolderIdFromOptions;
    }(),

    /**
     * @description Writes the file meta to the Firebase real-time db. Not intended as a public method.
     * Used internally by the `upload` method.
     * @param {object} [payload={}]
     * @returns {promise}
     * @private
     */
    _setFile: function _setFile() {
      var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var payload_ = typeof payload === 'object' ? Object.assign({}, payload, {
        __meta__: {
          createdBy: _get(authService_, 'currentUser.uid', 'UNKNOWN'),
          createdDate: new Date().toISOString()
        }
      }) : payload;
      return storageAPI.fileRef(payload.id).set(payload_);
    },

    /**
     * @description Resizes a given file to the size provided in the options config. Not for public use.
     * User internally by the `upload` method.
     * @param {File} file
     * @param {string} filename
     * @param {object} options
     * @returns {promise}
     * @private
     */
    _createSizedImage: function () {
      var _createSizedImage2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee15(file, filename) {
        var options,
            resizedImage,
            _args15 = arguments;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                options = _args15.length > 2 && _args15[2] !== undefined ? _args15[2] : {};

                if (!(options && (options.path || options.width || options.maxWidth))) {
                  _context15.next = 6;
                  break;
                }

                _context15.next = 4;
                return resizeImage(file, options);

              case 4:
                resizedImage = _context15.sent;
                return _context15.abrupt("return", storageAPI.ref(filename, {
                  path: options.path,
                  width: options.width || options.maxWidth
                }).put(resizedImage));

              case 6:
                throw error("Invalid size object supplied - please refer to https://flamelink.github.io/flamelink/#/storage?id=upload for more details on upload options.\nImage upload for supplied size skipped for file: ".concat(filename));

              case 7:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15);
      }));

      function _createSizedImage(_x6, _x7) {
        return _createSizedImage2.apply(this, arguments);
      }

      return _createSizedImage;
    }(),

    /**
     * @description Establish and return a reference to section in cloud storage bucket
     * @param {String} filename
     * @returns {Object} Ref object
     */
    ref: function ref(filename) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!storageService_) {
        throw error('The Storage service is not available. Make sure the "storageBucket" property is provided.');
      } // Check if the filename is a URL (contains "://")


      if (/:\/\//.test(filename)) {
        if (isAdminApp_) {
          throw error('Retrieving files from URL is not supported for the admin SDK');
        }

        return storageService_.refFromURL(filename);
      }

      return isAdminApp_ ? storageService_.bucket().file(getStorageRefPath(filename, options)) : storageService_.ref(getStorageRefPath(filename, options));
    },

    /**
     * @description Establish and return a reference to a folder in the real-time db
     * @param {String} folderID
     */
    folderRef: function folderRef(folderID) {
      if (!databaseService_) {
        throw error('The Database service is not available. Make sure the "databaseURL" property is provided.');
      }

      return databaseService_.ref(getFolderRefPath(folderID));
    },

    /**
     * @description Establish and return a reference to a file in the real-time db
     * @param {String} fileId
     */
    fileRef: function fileRef(fileId) {
      if (!databaseService_) {
        throw error('The Database service is not available. Make sure the "databaseURL" property is provided.');
      }

      return databaseService_.ref(getFileRefPath(fileId));
    },

    /**
     * @description Establish and return a reference to the media directory in the real-time db
     * @param {String} [mediaRef] Optional media reference
     */
    mediaRef: function mediaRef(_mediaRef) {
      if (!databaseService_) {
        throw error('The Database service is not available. Make sure the "databaseURL" property is provided.');
      }

      return databaseService_.ref(getMediaRefPath(_mediaRef));
    },

    /**
     * Read all or an individual media from the db and return snapshot response
     *
     * @param {String} [mediaRef] The media's key in the db
     * @param {Object} [options={}]
     * @returns {Promise} Resolves to snapshot of query
     */
    getRaw: function getRaw(mediaRef) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var ref = typeof mediaRef === 'string' ? mediaRef : null;
      var opts = typeof mediaRef === 'string' ? options : mediaRef || {};
      var ordered = applyOrderBy(storageAPI.mediaRef(ref), opts);
      var filtered = applyFilters(ordered, opts);
      return filtered.once(opts.event || 'value');
    },

    /**
     * Get all medias or an individual media object for the given reference
     *
     * @param {String} mediaRef The media's key in the db
     * @param {Object} [options={}]
     * @returns {Promise} Resolves to value of query
     */
    get: function () {
      var _get4 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee16(mediaRef) {
        var options,
            _pluckFields3,
            _snapshot3,
            _media,
            wrapValue,
            pluckFields,
            snapshot,
            media,
            _args16 = arguments;

        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                options = _args16.length > 1 && _args16[1] !== undefined ? _args16[1] : {};

                if (!(typeof mediaRef === 'string')) {
                  _context16.next = 9;
                  break;
                }

                // Single media
                _pluckFields3 = pluckResultFields(options.fields);
                _context16.next = 5;
                return storageAPI.getRaw(mediaRef, options);

              case 5:
                _snapshot3 = _context16.sent;
                _media = _snapshot3.val();
                wrapValue = _defineProperty({}, mediaRef, _media); // Wrapping value to create the correct structure for our filtering to work

                return _context16.abrupt("return", _pluckFields3(wrapValue)[mediaRef]);

              case 9:
                // All medias
                options = mediaRef || {};
                pluckFields = pluckResultFields(options.fields);
                _context16.next = 13;
                return storageAPI.getRaw(null, options);

              case 13:
                snapshot = _context16.sent;
                media = snapshot.val();
                return _context16.abrupt("return", pluckFields(media));

              case 16:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16);
      }));

      function get(_x8) {
        return _get4.apply(this, arguments);
      }

      return get;
    }(),

    /**
     * @description Establish stream to read value consistently from db, returning the raw snapshot
     * @param {String} [mediaKey]
     * @param {Object} [options={}]
     * @param {Function} cb
     * @returns {Promise} Resolves to snapshot of query
     */
    subscribeRaw: function subscribeRaw(mediaKey) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var cb = arguments.length > 2 ? arguments[2] : undefined;

      // Single media
      if (typeof mediaKey === 'string') {
        if (!cb) {
          cb = options; // second param is then the callback

          options = {}; // set default options
        }

        var _ordered2 = applyOrderBy(storageAPI.mediaRef(mediaKey), options);

        var _filtered2 = applyFilters(_ordered2, options);

        return _filtered2.on(options.event || 'value', cb);
      } // All medias


      cb = options;
      options = mediaKey || {};

      if (typeof cb === 'object') {
        cb = mediaKey; // first param is then the callback

        options = {}; // set default options
      }

      var ordered = applyOrderBy(storageAPI.mediaRef(null), options);
      var filtered = applyFilters(ordered, options);
      return filtered.on(options.event || 'value', cb);
    },

    /**
     * @description Establish stream to read value consistently from db, returning the processed value
     * @param {String} [mediaKey]
     * @param {Object} [options={}]
     * @param {Function} cb
     * @returns {Promise} Resolves to value of query
     */
    subscribe: function subscribe(mediaKey) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var cb = arguments.length > 2 ? arguments[2] : undefined;

      try {
        // Single media
        if (typeof mediaKey === 'string') {
          if (!cb || typeof options === 'function') {
            cb = options; // second param is then the callback

            options = {}; // set default options
          }

          var _pluckFields4 = pluckResultFields(options.fields);

          return storageAPI.subscribeRaw(mediaKey, options,
          /*#__PURE__*/
          function () {
            var _ref5 = _asyncToGenerator(
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee17(snapshot) {
              var wrappedMedia, media;
              return _regeneratorRuntime.wrap(function _callee17$(_context17) {
                while (1) {
                  switch (_context17.prev = _context17.next) {
                    case 0:
                      _context17.next = 2;
                      return compose(_pluckFields4)(_defineProperty({}, mediaKey, snapshot.val()));

                    case 2:
                      wrappedMedia = _context17.sent;
                      media = wrappedMedia[mediaKey];
                      return _context17.abrupt("return", cb(null, media));

                    case 5:
                    case "end":
                      return _context17.stop();
                  }
                }
              }, _callee17);
            }));

            return function (_x9) {
              return _ref5.apply(this, arguments);
            };
          }());
        } // All medias


        cb = options;
        options = mediaKey || {};

        if (typeof cb === 'object') {
          cb = mediaKey; // first param is then the callback

          options = {}; // set default options
        }

        var pluckFields = pluckResultFields(options.fields);
        return storageAPI.subscribeRaw(options,
        /*#__PURE__*/
        function () {
          var _ref6 = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee18(snapshot) {
            var pluckedMedia;
            return _regeneratorRuntime.wrap(function _callee18$(_context18) {
              while (1) {
                switch (_context18.prev = _context18.next) {
                  case 0:
                    _context18.next = 2;
                    return compose(pluckFields)(snapshot.val());

                  case 2:
                    pluckedMedia = _context18.sent;
                    cb(null, pluckedMedia); // Error-first callback

                  case 4:
                  case "end":
                    return _context18.stop();
                }
              }
            }, _callee18);
          }));

          return function (_x10) {
            return _ref6.apply(this, arguments);
          };
        }());
      } catch (err) {
        return cb(err);
      }
    },

    /**
     * @description Detach listeners from given reference.
     * @param {String} mediaKey
     * @param {String} event
     * @returns {Promise}
     */
    unsubscribe: function unsubscribe() {
      if (arguments.length === 2) {
        // Is second arg a valid firebase child event?
        if (ALLOWED_CHILD_EVENTS.includes(arguments.length <= 1 ? undefined : arguments[1])) {
          // args[0] = mediaKey
          // args[1] = event
          return storageAPI.mediaRef(arguments.length <= 0 ? undefined : arguments[0]).off(arguments.length <= 1 ? undefined : arguments[1]);
        }

        throw error("\"".concat(arguments.length <= 1 ? undefined : arguments[1], "\" is not a valid child event"));
      }

      if (arguments.length === 1) {
        return storageAPI.mediaRef(arguments.length <= 0 ? undefined : arguments[0]).off();
      }

      throw error('"unsubscribe" method needs to be called with min 1 argument and max 2 arguments');
    },

    /**
     * Read value once from db and return raw snapshot
     *
     * @param {Object} [options={}]
     * @returns {Promise} Resolves to snapshot of query
     */
    getFoldersRaw: function getFoldersRaw() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var ordered = applyOrderBy(storageAPI.folderRef(), options);
      var filtered = applyFilters(ordered, options);
      return filtered.once(options.event || 'value');
    },

    /**
     * Read value once from db
     *
     * @param {Object} [options={}]
     * @returns {Promise} Resolves to value of query
     */
    getFolders: function () {
      var _getFolders = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee19() {
        var options,
            pluckFields,
            structureItems,
            snapshot,
            _args19 = arguments;
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                options = _args19.length > 0 && _args19[0] !== undefined ? _args19[0] : {};
                pluckFields = pluckResultFields(options.fields);
                structureItems = formatStructure(options.structure, {
                  idProperty: 'id',
                  parentProperty: 'parentId'
                });
                _context19.next = 5;
                return storageAPI.getFoldersRaw(options);

              case 5:
                snapshot = _context19.sent;
                return _context19.abrupt("return", compose(pluckFields, structureItems, values)(snapshot.val()));

              case 7:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19);
      }));

      function getFolders() {
        return _getFolders.apply(this, arguments);
      }

      return getFolders;
    }(),

    /**
     * Read value once from db and return raw snapshot
     *
     * @param {String} fileId
     * @param {Object} [options={}]
     * @returns {Promise} Resolves to snapshot of query
     */
    getFileRaw: function getFileRaw(fileId) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!fileId) {
        throw error('"storage.getFileRaw()" should be called with at least the file ID');
      }

      var ordered = applyOrderBy(storageAPI.fileRef(fileId), options);
      var filtered = applyFilters(ordered, options);
      return filtered.once(options.event || 'value');
    },

    /**
     * @description Read the file object from the database
     * @param {String} fileId
     * @param {Object} [options={}]
     * @returns {Promise} Resolves to value of query
     */
    getFile: function () {
      var _getFile = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee20(fileId) {
        var options,
            pluckFields,
            snapshot,
            wrapValue,
            file,
            _args20 = arguments;
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                options = _args20.length > 1 && _args20[1] !== undefined ? _args20[1] : {};

                if (fileId) {
                  _context20.next = 3;
                  break;
                }

                throw error('"storage.getFile()" should be called with at least the file ID');

              case 3:
                pluckFields = pluckResultFields(options.fields);
                _context20.next = 6;
                return storageAPI.getFileRaw(fileId, options);

              case 6:
                snapshot = _context20.sent;
                wrapValue = _defineProperty({}, fileId, snapshot.val()); // Wrapping value to create the correct structure for our filtering to work

                _context20.next = 10;
                return compose(pluckFields)(wrapValue);

              case 10:
                file = _context20.sent;
                return _context20.abrupt("return", file[fileId]);

              case 12:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20);
      }));

      function getFile(_x11) {
        return _getFile.apply(this, arguments);
      }

      return getFile;
    }(),

    /**
     * Read value once from db and return raw snapshot
     *
     * @param {Object} [options={}]
     * @returns {Promise} Resolves to snapshot of query
     */
    getFilesRaw: function getFilesRaw() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var ordered = applyOrderBy(storageAPI.fileRef(), options);
      var filtered = applyFilters(ordered, options);
      return filtered.once(options.event || 'value');
    },

    /**
     * Read value once from db
     *
     * @param {Object} [options={}]
     * @returns {Promise} Resolves to value of query
     */
    getFiles: function () {
      var _getFiles = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee21() {
        var options,
            defaultOptions,
            opts,
            folderId,
            filterFolders,
            pluckFields,
            snapshot,
            _args21 = arguments;
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                options = _args21.length > 0 && _args21[0] !== undefined ? _args21[0] : {};
                defaultOptions = {
                  folderFallback: null
                };
                opts = Object.assign(defaultOptions, options, options.mediaType ? {
                  orderByChild: 'type',
                  equalTo: options.mediaType
                } : {});
                _context21.next = 5;
                return storageAPI._getFolderIdFromOptions(opts);

              case 5:
                folderId = _context21.sent;
                filterFolders = filterByFolderId(folderId);
                pluckFields = pluckResultFields(opts.fields);
                _context21.next = 10;
                return storageAPI.getFilesRaw(opts);

              case 10:
                snapshot = _context21.sent;
                return _context21.abrupt("return", compose(pluckFields, filterFolders)(snapshot.val()));

              case 12:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21);
      }));

      function getFiles() {
        return _getFiles.apply(this, arguments);
      }

      return getFiles;
    }(),

    /**
     * @description Given a fileId, return the download URL
     * @param {String} fileId
     * @param {Object} [options={}]
     * @returns {Promise} Resolves to download URL string
     */
    getURL: function () {
      var _getURL = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee22(fileId) {
        var options,
            size,
            file,
            _ref7,
            filename,
            availableFileSizes,
            storageRefArgs,
            getImagePathByClosestSize,
            width,
            height,
            quality,
            minSize,
            fileRef,
            signedUrls,
            _args22 = arguments;

        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                options = _args22.length > 1 && _args22[1] !== undefined ? _args22[1] : {};

                if (fileId) {
                  _context22.next = 3;
                  break;
                }

                throw error('"storage.getURL()" should be called with at least the file ID');

              case 3:
                size = options.size;
                _context22.next = 6;
                return storageAPI.getFile(fileId, options);

              case 6:
                file = _context22.sent;

                if (file) {
                  _context22.next = 9;
                  break;
                }

                return _context22.abrupt("return", file);

              case 9:
                _ref7 = file || {}, filename = _ref7.file, availableFileSizes = _ref7.sizes;
                storageRefArgs = [filename];

                getImagePathByClosestSize = function getImagePathByClosestSize(minSize) {
                  var smartWidth = availableFileSizes.map(function (availableSize) {
                    return Object.assign({}, availableSize, {
                      width: parseInt(availableSize.width || availableSize.maxWidth, 10)
                    });
                  }, []).sort(function (a, b) {
                    return a.width - b.width;
                  }) // sort widths ascending
                  .find(function (availableSize) {
                    return availableSize.width >= minSize;
                  });

                  if (smartWidth) {
                    storageRefArgs.push(smartWidth);
                  } else {
                    console.warn("[FLAMELINK]: The provided size (".concat(size, ") has been ignored because it did not match any of the given file's available sizes.\nAvailable sizes: ").concat(availableFileSizes.map(function (availableSize) {
                      return availableSize.width;
                    }).join(', ')));
                  }
                };

                if (typeof size === 'object') {
                  width = size.width, height = size.height, quality = size.quality;

                  if (typeof width !== 'undefined' && typeof height !== 'undefined' && typeof quality !== 'undefined') {
                    size.path = "".concat(width, "_").concat(height, "_").concat(Math.round(parseFloat(quality, 10) * 100));
                  } // For images with `path` value


                  if (size.path && availableFileSizes && _get(availableFileSizes, '[0].path')) {
                    if (availableFileSizes.find(function (_ref8) {
                      var filePath = _ref8.path;
                      return filePath === size.path;
                    })) {
                      storageRefArgs.push({
                        path: size.path
                      });
                    } else {
                      console.warn("[FLAMELINK]: The provided path (".concat(size.path, ") has been ignored because it did not match any of the given file's available paths.\nAvailable paths: ").concat(availableFileSizes.map(function (availableSize) {
                        return availableSize.path;
                      }).join(', ')));
                    }
                  } else if (width && availableFileSizes && availableFileSizes.length) {
                    getImagePathByClosestSize(width);
                  }
                } else if (size && availableFileSizes && availableFileSizes.length) {
                  // This part is for the special 'device' use case and for the legacy width setting
                  minSize = size === 'device' ? getScreenResolution() : size;
                  getImagePathByClosestSize(minSize);
                }

                _context22.next = 15;
                return storageAPI.ref.apply(storageAPI, storageRefArgs);

              case 15:
                fileRef = _context22.sent;

                if (!isAdminApp_) {
                  _context22.next = 21;
                  break;
                }

                _context22.next = 19;
                return fileRef.getSignedUrl({
                  action: 'read',
                  expires: '01-01-2500' // Just expire at some very far time in the future

                });

              case 19:
                signedUrls = _context22.sent;
                return _context22.abrupt("return", _get(signedUrls, '[0]', ''));

              case 21:
                return _context22.abrupt("return", fileRef.getDownloadURL());

              case 22:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22);
      }));

      function getURL(_x12) {
        return _getURL.apply(this, arguments);
      }

      return getURL;
    }(),

    /**
     * @description Get the Google Cloud Storage Bucket metadata for a given file
     * @param {String|Number} fileId
     * @returns {Promise}
     */
    getMetadata: function () {
      var _getMetadata = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee23(fileId) {
        var options,
            file,
            filename,
            _args23 = arguments;
        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                options = _args23.length > 1 && _args23[1] !== undefined ? _args23[1] : {};

                if (fileId) {
                  _context23.next = 3;
                  break;
                }

                throw error('"storage.getMetadata()" should be called with at least the file ID');

              case 3:
                _context23.next = 5;
                return storageAPI.getFile(fileId, options);

              case 5:
                file = _context23.sent;

                if (file) {
                  _context23.next = 8;
                  break;
                }

                throw error("There is no file for File ID: \"".concat(fileId, "\""));

              case 8:
                filename = file.file;
                return _context23.abrupt("return", storageAPI.ref(filename).getMetadata());

              case 10:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23);
      }));

      function getMetadata(_x13) {
        return _getMetadata.apply(this, arguments);
      }

      return getMetadata;
    }(),

    /**
     * @description Update the Google Cloud Storage Bucket metadata for a given file
     * @param {String|Number} fileId
     * @param {Object|Null} payload
     * @returns {Promise}
     */
    updateMetadata: function () {
      var _updateMetadata = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee24(fileId) {
        var payload,
            file,
            filename,
            _args24 = arguments;
        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                payload = _args24.length > 1 && _args24[1] !== undefined ? _args24[1] : {};

                if (fileId) {
                  _context24.next = 3;
                  break;
                }

                throw error('"storage.updateMetadata()" should be called with at least the file ID');

              case 3:
                _context24.next = 5;
                return storageAPI.getFile(fileId);

              case 5:
                file = _context24.sent;

                if (file) {
                  _context24.next = 8;
                  break;
                }

                throw error("There is no file for File ID: \"".concat(fileId, "\""));

              case 8:
                filename = file.file;
                return _context24.abrupt("return", storageAPI.ref(filename).updateMetadata(payload));

              case 10:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24);
      }));

      function updateMetadata(_x14) {
        return _updateMetadata.apply(this, arguments);
      }

      return updateMetadata;
    }(),

    /**
     * @description Delete a given file from the Cloud Storage Bucket as well as the real-time db
     * @param {String|Number} fileId
     * @returns {Promise}
     */
    deleteFile: function () {
      var _deleteFile = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee26(fileId) {
        var options,
            file,
            filename,
            sizes,
            storageRef,
            _args26 = arguments;
        return _regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                options = _args26.length > 1 && _args26[1] !== undefined ? _args26[1] : {};

                if (!isAdminApp_) {
                  _context26.next = 3;
                  break;
                }

                throw error('"storage.deleteFile()" is not currently supported for server-side use.');

              case 3:
                if (fileId) {
                  _context26.next = 5;
                  break;
                }

                throw error('"storage.deleteFile()" should be called with at least the file ID');

              case 5:
                _context26.next = 7;
                return storageAPI.getFile(fileId, options);

              case 7:
                file = _context26.sent;

                if (file) {
                  _context26.next = 10;
                  break;
                }

                return _context26.abrupt("return", file);

              case 10:
                filename = file.file, sizes = file.sizes;
                storageRef = storageAPI.ref(filename); // Delete original file from storage bucket

                _context26.next = 14;
                return storageRef.delete();

              case 14:
                if (!Array.isArray(sizes)) {
                  _context26.next = 17;
                  break;
                }

                _context26.next = 17;
                return Promise.all(sizes.map(
                /*#__PURE__*/
                function () {
                  var _ref9 = _asyncToGenerator(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee25(size) {
                    var width, path;
                    return _regeneratorRuntime.wrap(function _callee25$(_context25) {
                      while (1) {
                        switch (_context25.prev = _context25.next) {
                          case 0:
                            width = size.width || size.maxWidth;
                            path = size.path;

                            if (!(!width && !path)) {
                              _context25.next = 4;
                              break;
                            }

                            return _context25.abrupt("return", Promise.resolve());

                          case 4:
                            return _context25.abrupt("return", storageAPI.ref(filename, {
                              width: width,
                              path: path
                            }).delete());

                          case 5:
                          case "end":
                            return _context25.stop();
                        }
                      }
                    }, _callee25);
                  }));

                  return function (_x16) {
                    return _ref9.apply(this, arguments);
                  };
                }()));

              case 17:
                return _context26.abrupt("return", storageAPI.fileRef(fileId).remove());

              case 18:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26);
      }));

      function deleteFile(_x15) {
        return _deleteFile.apply(this, arguments);
      }

      return deleteFile;
    }(),

    /**
     * @description Upload a given file to the Cloud Storage Bucket as well as the real-time db
     * @param {String|File|Blob|Uint8Array} fileData
     * @param {Object} [options={}]
     * @returns {Object} UploadTask instance, which is similar to a Promise and an Observable
     */
    upload: function () {
      var _upload = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee27(fileData) {
        var options,
            userSizes,
            overwriteSizes,
            settingsImageSizes,
            id,
            metadata,
            filename,
            storageRef,
            updateMethod,
            args,
            folderId,
            uploadTask,
            snapshot,
            mediaType,
            filePayload,
            _args27 = arguments;
        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                options = _args27.length > 1 && _args27[1] !== undefined ? _args27[1] : {};

                if (!isAdminApp_) {
                  _context27.next = 3;
                  break;
                }

                throw error('"storage.upload()" is not currently supported for server-side use.');

              case 3:
                userSizes = options.sizes, overwriteSizes = options.overwriteSizes;
                _context27.next = 6;
                return settingsAPI.getImageSizes();

              case 6:
                settingsImageSizes = _context27.sent;

                if (!userSizes && !overwriteSizes) {
                  set(options, 'sizes', settingsImageSizes || []);
                } else if (userSizes && userSizes.length && !overwriteSizes) {
                  set(options, 'sizes', [].concat(_toConsumableArray(settingsImageSizes), _toConsumableArray(userSizes)) || []);
                } // Ensure image size with width DEFAULT_REQUIRED_IMAGE_SIZE exists
                // Flamelink CMS expects file to reside in `240` folder, so size if only `width: 240` should be passed


                if (!options.sizes || options.sizes && options.sizes.length === 0 || Array.isArray(options.sizes) && options.sizes.filter(function (size) {
                  return (size.width === DEFAULT_REQUIRED_IMAGE_SIZE || size.maxWidth === DEFAULT_REQUIRED_IMAGE_SIZE) && !size.height && !size.quality;
                }).length === 0) {
                  if (Array.isArray(options.sizes)) {
                    options.sizes.push({
                      width: DEFAULT_REQUIRED_IMAGE_SIZE
                    });
                  } else {
                    set(options, 'sizes', [{
                      width: DEFAULT_REQUIRED_IMAGE_SIZE
                    }]);
                  }
                }

                id = Date.now().toString();
                metadata = _get(options, 'metadata', {});
                filename = typeof fileData === 'object' && fileData.name || typeof metadata.name === 'string' ? "".concat(id, "_").concat(metadata.name || fileData.name) : id;
                storageRef = storageAPI.ref(filename, options);
                updateMethod = typeof fileData === 'string' ? 'putString' : 'put';
                args = [fileData];
                _context27.next = 17;
                return storageAPI._getFolderIdFromOptions(options);

              case 17:
                folderId = _context27.sent;

                if (typeof folderId === 'number') {
                  folderId = folderId.toString();
                }

                set(options, 'metadata.customMetadata.flamelinkFileId', id);
                set(options, 'metadata.customMetadata.flamelinkFolderId', folderId);
                args.push(options.metadata); // TODO: Test and verify how the Firebase SDK handles string uploads with encoding and metadata
                // Is it the second argument then or should it be passed along with the metadata object?

                if (updateMethod === 'putString' && options.stringEncoding) {
                  args.splice(1, 0, options.stringEncoding);
                } // Upload original file to storage bucket


                uploadTask = storageRef[updateMethod].apply(storageRef, args);
                _context27.next = 26;
                return uploadTask;

              case 26:
                snapshot = _context27.sent;
                mediaType = /^image\//.test(_get(snapshot, 'metadata.contentType')) ? 'images' : 'files';
                filePayload = {
                  id: id,
                  file: _get(snapshot, 'metadata.name', ''),
                  folderId: folderId,
                  type: mediaType,
                  contentType: _get(snapshot, 'metadata.contentType', '')
                }; // If mediaType === 'images', file is resizeable and sizes/widths are set, resize images here

                if (!(mediaType === 'images' && updateMethod === 'put' && Array.isArray(options.sizes))) {
                  _context27.next = 33;
                  break;
                }

                filePayload.sizes = options.sizes.map(function (size) {
                  var width = size.width,
                      height = size.height,
                      quality = size.quality;

                  if (typeof width !== 'undefined' && typeof height !== 'undefined' && typeof quality !== 'undefined') {
                    return Object.assign({}, size, {
                      path: "".concat(width, "_").concat(height, "_").concat(Math.round(quality * 100))
                    });
                  }

                  return size;
                });
                _context27.next = 33;
                return Promise.all(filePayload.sizes.map(function (size) {
                  return storageAPI._createSizedImage(fileData, filename, size);
                }));

              case 33:
                _context27.next = 35;
                return storageAPI._setFile(filePayload);

              case 35:
                return _context27.abrupt("return", uploadTask);

              case 36:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27);
      }));

      function upload(_x17) {
        return _upload.apply(this, arguments);
      }

      return upload;
    }()
  };
  var contentAPI = {
    /**
     * @description Establish and return a reference to section in firebase db
     * @param {String|String[]} ref
     * @returns {Object} Ref object
     */
    ref: function ref(_ref10) {
      if (!databaseService_) {
        throw error('The Database service is not available. Make sure the "databaseURL" property is provided.');
      }

      return databaseService_.ref(getContentRefPath(_ref10, env_, locale_));
    },

    /**
     * @description Read entries/entry for given content type and optional entry reference and return raw snapshot
     * @param {String} contentRef
     * @param {String} entryRef
     * @param {Object} [options={}]
     * @returns {Promise} Resolves to snapshot of query
     */
    getRaw: function getRaw(contentRef, entryRef) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      // Is single entry query?
      if (['string', 'number'].includes(typeof entryRef)) {
        var _ordered3 = applyOrderBy(contentAPI.ref([contentRef, entryRef]), options);

        var _filtered3 = applyFilters(_ordered3, options);

        return _filtered3.once(options.event || 'value');
      } // Query all entries for given content type


      var ref = typeof contentRef === 'string' ? contentRef : null;
      var opts = typeof contentRef === 'string' ? entryRef || {} : contentRef || {};
      var ordered = applyOrderBy(contentAPI.ref(ref), opts);
      var filtered = applyFilters(ordered, opts);
      return filtered.once(opts.event || 'value');
    },

    /**
     * @description Get entries/entry for given content type and optional entry ID/reference
     * @param {String} contentRef
     * @param {String} entryRef
     * @param {Object} [options={}]
     * @returns {Promise} Resolves to value of query
     */
    get: function () {
      var _get5 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee28(contentRef, entryRef) {
        var options,
            _pluckFields5,
            _populateFields,
            _snapshot4,
            wrapValue,
            _result,
            schema,
            isSingleType,
            ref,
            opts,
            pluckFields,
            populateFields,
            snapshot,
            value,
            _result2,
            withLocales,
            currentLocale,
            withoutLocales,
            result,
            _args28 = arguments;

        return _regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                options = _args28.length > 2 && _args28[2] !== undefined ? _args28[2] : {};

                if (!['string', 'number'].includes(typeof entryRef)) {
                  _context28.next = 12;
                  break;
                }

                _pluckFields5 = pluckResultFields(options.fields);
                _populateFields = populateEntry(schemasAPI, contentAPI, storageAPI, contentRef, options.populate);
                _context28.next = 6;
                return contentAPI.getRaw(contentRef, entryRef, options);

              case 6:
                _snapshot4 = _context28.sent;
                wrapValue = _defineProperty({}, entryRef, _snapshot4.val()); // Wrapping value to create the correct structure for our filtering to work

                _context28.next = 10;
                return compose(_populateFields, _pluckFields5)(wrapValue);

              case 10:
                _result = _context28.sent;
                return _context28.abrupt("return", _result[entryRef]);

              case 12:
                _context28.next = 14;
                return schemasAPI.get(contentRef);

              case 14:
                schema = _context28.sent;
                isSingleType = schema && schema.type === 'single'; // Query all entries for given content type

                ref = typeof contentRef === 'string' ? contentRef : null;
                opts = typeof contentRef === 'string' ? entryRef || {} : contentRef || {};
                pluckFields = pluckResultFields(opts.fields);
                populateFields = populateEntry(schemasAPI, contentAPI, storageAPI, contentRef, opts.populate);
                _context28.next = 22;
                return contentAPI.getRaw(ref, opts);

              case 22:
                snapshot = _context28.sent;

                if (!ref) {
                  _context28.next = 29;
                  break;
                }

                value = isSingleType ? _defineProperty({}, ref, snapshot.val()) : snapshot.val();
                _context28.next = 27;
                return compose(populateFields, pluckFields)(value);

              case 27:
                _result2 = _context28.sent;
                return _context28.abrupt("return", isSingleType ? _result2[ref] : _result2);

              case 29:
                withLocales = snapshot.val();
                currentLocale = locale_; // TODO: Look at getting from API method

                withoutLocales = keys(withLocales).reduce(function (menus, key) {
                  return Object.assign({}, menus, _defineProperty({}, key, withLocales[key][currentLocale]));
                }, {});
                _context28.next = 34;
                return compose(populateFields, pluckFields)(withoutLocales);

              case 34:
                result = _context28.sent;
                return _context28.abrupt("return", result);

              case 36:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28);
      }));

      function get(_x18, _x19) {
        return _get5.apply(this, arguments);
      }

      return get;
    }(),

    /**
     * Get an entry for a given content reference, field and value.
     *
     * @param {String} contentRef
     * @param {String} field
     * @param {String} value
     * @param {Object} [options={}]
     * @returns {Promise} Resolves to snapshot of query
     */
    getByFieldRaw: function getByFieldRaw(contentRef, field, value) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var opts = Object.assign({}, options, {
        orderByChild: field,
        equalTo: value
      });
      return contentAPI.getRaw(contentRef, opts);
    },

    /**
     * Get an entry for a given content reference, field and value.
     *
     * @param {String} contentRef
     * @param {String} field
     * @param {String} value
     * @param {Object} [options={}]
     * @returns {Promise} Resolves to value of query
     */
    getByField: function getByField(contentRef, field, value) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var opts = Object.assign({}, options, {
        orderByChild: field,
        equalTo: value
      });
      return contentAPI.get(contentRef, opts);
    },

    /**
     * Establish stream to read value consistently from db, returning the raw snapshot
     *
     * @param {String} contentRef
     * @param {String} entryRef
     * @param {Object} [options={}]
     * @param {Function} cb
     * @returns {Promise} Resolves to snapshot of query
     */
    subscribeRaw: function subscribeRaw(contentRef, entryRef) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var cb = arguments.length > 3 ? arguments[3] : undefined;

      // Is single entry subscription?
      if (['string', 'number'].includes(typeof entryRef)) {
        if (!cb) {
          cb = options;
          options = {};
        }

        var _ordered4 = applyOrderBy(contentAPI.ref([contentRef, entryRef]), options);

        var _filtered4 = applyFilters(_ordered4, options);

        return _filtered4.on(options.event || 'value', cb);
      } // Subscribe to all entries for given content type


      if (typeof entryRef === 'object') {
        cb = options; // third param is then the callback

        options = entryRef; // second param is then the options
      } else if (typeof entryRef === 'function') {
        cb = entryRef; // second param is then the callback

        options = {}; // set default options
      } else if (typeof contentRef === 'function') {
        cb = contentRef; // first param is then the callback

        options = {}; // set default options

        contentRef = null;
      } else {
        throw error('Check out the docs for the required parameters for this method');
      }

      var ordered = applyOrderBy(contentAPI.ref(contentRef), options);
      var filtered = applyFilters(ordered, options);
      return filtered.on(options.event || 'value', cb);
    },

    /**
     * Establish stream to read value consistently from db, returning the processed value
     *
     * @param {String} contentRef
     * @param {String} entryRef
     * @param {Object} [options={}]
     * @param {Function} cb
     * @returns {Promise} Resolves to value of query
     */
    subscribe: function () {
      var _subscribe = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee31(contentRef, entryRef) {
        var options,
            cb,
            _pluckFields6,
            _populateFields2,
            schema,
            isSingleType,
            pluckFields,
            populateFields,
            _args31 = arguments;

        return _regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                options = _args31.length > 2 && _args31[2] !== undefined ? _args31[2] : {};
                cb = _args31.length > 3 ? _args31[3] : undefined;
                _context31.prev = 2;

                if (!['string', 'number'].includes(typeof entryRef)) {
                  _context31.next = 8;
                  break;
                }

                if (!cb) {
                  cb = options;
                  options = {};
                }

                _pluckFields6 = pluckResultFields(options.fields);
                _populateFields2 = populateEntry(schemasAPI, contentAPI, storageAPI, contentRef, options.populate);
                return _context31.abrupt("return", contentAPI.subscribeRaw(contentRef, entryRef, options,
                /*#__PURE__*/
                function () {
                  var _ref12 = _asyncToGenerator(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee29(snapshot) {
                    var wrapValue, result;
                    return _regeneratorRuntime.wrap(function _callee29$(_context29) {
                      while (1) {
                        switch (_context29.prev = _context29.next) {
                          case 0:
                            wrapValue = _defineProperty({}, entryRef, snapshot.val()); // Wrapping value to create the correct structure for our filtering to work

                            _context29.next = 3;
                            return compose(_populateFields2, _pluckFields6)(wrapValue);

                          case 3:
                            result = _context29.sent;
                            cb(null, result[entryRef]); // Error-first callback

                          case 5:
                          case "end":
                            return _context29.stop();
                        }
                      }
                    }, _callee29);
                  }));

                  return function (_x22) {
                    return _ref12.apply(this, arguments);
                  };
                }()));

              case 8:
                if (!(typeof entryRef === 'object')) {
                  _context31.next = 13;
                  break;
                }

                cb = options; // third param is then the callback

                options = entryRef; // second param is then the options

                _context31.next = 25;
                break;

              case 13:
                if (!(typeof entryRef === 'function')) {
                  _context31.next = 18;
                  break;
                }

                cb = entryRef; // second param is then the callback

                options = {}; // set default options

                _context31.next = 25;
                break;

              case 18:
                if (!(typeof contentRef === 'function')) {
                  _context31.next = 24;
                  break;
                }

                cb = contentRef; // first param is then the callback

                options = {}; // set default options

                contentRef = null;
                _context31.next = 25;
                break;

              case 24:
                throw error('Check out the docs for the required parameters for this method');

              case 25:
                _context31.next = 27;
                return schemasAPI.get(contentRef);

              case 27:
                schema = _context31.sent;
                isSingleType = schema && schema.type === 'single';
                pluckFields = pluckResultFields(options.fields);
                populateFields = populateEntry(schemasAPI, contentAPI, storageAPI, contentRef, options.populate);
                return _context31.abrupt("return", contentAPI.subscribeRaw(contentRef, options,
                /*#__PURE__*/
                function () {
                  var _ref13 = _asyncToGenerator(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee30(snapshot) {
                    var value, _result3, withLocales, currentLocale, withoutLocales, result;

                    return _regeneratorRuntime.wrap(function _callee30$(_context30) {
                      while (1) {
                        switch (_context30.prev = _context30.next) {
                          case 0:
                            if (!contentRef) {
                              _context30.next = 7;
                              break;
                            }

                            value = isSingleType ? _defineProperty({}, contentRef, snapshot.val()) : snapshot.val();
                            _context30.next = 4;
                            return compose(populateFields, pluckFields)(value);

                          case 4:
                            _result3 = _context30.sent;
                            cb(null, isSingleType ? _result3[contentRef] : _result3); // Error-first callback

                            return _context30.abrupt("return");

                          case 7:
                            withLocales = snapshot.val();
                            currentLocale = locale_; // TODO: Look at getting from API method

                            withoutLocales = keys(withLocales).reduce(function (menus, key) {
                              return Object.assign({}, menus, _defineProperty({}, key, withLocales[key][currentLocale]));
                            }, {});
                            _context30.next = 12;
                            return compose(populateFields, pluckFields)(withoutLocales);

                          case 12:
                            result = _context30.sent;
                            cb(null, result); // Error-first callback

                          case 14:
                          case "end":
                            return _context30.stop();
                        }
                      }
                    }, _callee30);
                  }));

                  return function (_x23) {
                    return _ref13.apply(this, arguments);
                  };
                }()));

              case 34:
                _context31.prev = 34;
                _context31.t0 = _context31["catch"](2);
                return _context31.abrupt("return", cb(_context31.t0));

              case 37:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31, null, [[2, 34]]);
      }));

      function subscribe(_x20, _x21) {
        return _subscribe.apply(this, arguments);
      }

      return subscribe;
    }(),

    /**
     * Detach event listeners from given reference.
     *
     * @param {String} contentRef
     * @param {String} entryRef
     * @param {String} event
     * @returns {Promise}
     */
    unsubscribe: function unsubscribe() {
      if (arguments.length === 3) {
        // args[0] = contentRef
        // args[1] = entryRef
        // args[2] = event
        return contentAPI.ref([arguments.length <= 0 ? undefined : arguments[0], arguments.length <= 1 ? undefined : arguments[1]]).off(arguments.length <= 2 ? undefined : arguments[2]);
      }

      if (arguments.length === 2) {
        // Is second arg a valid firebase child event?
        if (ALLOWED_CHILD_EVENTS.includes(arguments.length <= 1 ? undefined : arguments[1])) {
          // args[0] = contentRef
          // args[1] = event
          return contentAPI.ref(arguments.length <= 0 ? undefined : arguments[0]).off(arguments.length <= 1 ? undefined : arguments[1]);
        } // args[0] = contentRef
        // args[1] = entryRef


        return contentAPI.ref([arguments.length <= 0 ? undefined : arguments[0], arguments.length <= 1 ? undefined : arguments[1]]).off();
      }

      if (arguments.length === 1) {
        return contentAPI.ref(arguments.length <= 0 ? undefined : arguments[0]).off();
      }

      throw error('"unsubscribe" method needs to be called with min 1 argument and max 3 arguments');
    },

    /**
     * Save data for a specific content type's entry.
     * This overwrites data at the specified location, including any child nodes.
     *
     * @param {String} contentRef
     * @param {String} [entryRef]
     * @param {Object} payload
     * @returns {Promise}
     */
    set: function () {
      var _set = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee32(contentRef, entryRef, payload) {
        var schema, isSingleType, payload_, _schema$fields, fields, constraints, validationErrors, fieldKeys, pickFields;

        return _regeneratorRuntime.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                _context32.next = 2;
                return schemasAPI.get(contentRef);

              case 2:
                schema = _context32.sent;
                isSingleType = schema && schema.type === 'single';
                payload_ = isSingleType ? entryRef : payload;

                if (!(isSingleType && (typeof contentRef !== 'string' || typeof payload_ !== 'object' && payload_ !== null) || !isSingleType && (typeof contentRef !== 'string' || typeof entryRef !== 'string' || typeof payload_ !== 'object' && payload_ !== null))) {
                  _context32.next = 7;
                  break;
                }

                throw error('"set" called with the incorrect arguments. Check the docs for details.');

              case 7:
                _schema$fields = schema.fields, fields = _schema$fields === void 0 ? [] : _schema$fields;
                constraints = fields.reduce(function (rules, field) {
                  return Object.assign({}, rules, _defineProperty({}, field.key, prepConstraintsForValidate(field.constraints)));
                }, {});
                validationErrors = validate(payload_, constraints);

                if (!validationErrors) {
                  _context32.next = 12;
                  break;
                }

                return _context32.abrupt("return", Promise.reject(validationErrors));

              case 12:
                fieldKeys = fields.map(function (field) {
                  return field.key;
                });
                pickFields = pick(fieldKeys);

                if (typeof payload_ === 'object') {
                  payload_ = Object.assign({}, pickFields(payload_), {
                    __meta__: {
                      createdBy: _get(authService_, 'currentUser.uid', 'UNKNOWN'),
                      createdDate: new Date().toISOString()
                    },
                    id: isSingleType ? contentRef : entryRef
                  });
                }

                if (!isSingleType) {
                  _context32.next = 17;
                  break;
                }

                return _context32.abrupt("return", contentAPI.ref(contentRef).set(payload_));

              case 17:
                return _context32.abrupt("return", contentAPI.ref([contentRef, entryRef]).set(payload_));

              case 18:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee32);
      }));

      function set(_x24, _x25, _x26) {
        return _set.apply(this, arguments);
      }

      return set;
    }(),

    /**
     * Simultaneously write to specific children of a node without overwriting other child nodes.
     *
     * @param {String} contentRef
     * @param {String} entryRef
     * @param {Object} payload
     * @returns {Promise}
     */
    update: function () {
      var _update = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee33(contentRef, entryRef, payload) {
        var schema, isSingleType, payload_, _schema$fields2, fields, constraints, validationErrors, fieldKeys, pickFields;

        return _regeneratorRuntime.wrap(function _callee33$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                if (typeof entryRef === 'number') {
                  entryRef = entryRef.toString();
                }

                _context33.next = 3;
                return schemasAPI.get(contentRef);

              case 3:
                schema = _context33.sent;
                isSingleType = schema && schema.type === 'single';
                payload_ = isSingleType ? entryRef : payload;

                if (!(isSingleType && (typeof contentRef !== 'string' || typeof payload_ !== 'object' && payload_ !== null) || !isSingleType && (typeof contentRef !== 'string' || typeof entryRef !== 'string' || typeof payload_ !== 'object' && payload_ !== null))) {
                  _context33.next = 8;
                  break;
                }

                throw error('"update" called with the incorrect arguments. Check the docs for details.');

              case 8:
                _schema$fields2 = schema.fields, fields = _schema$fields2 === void 0 ? [] : _schema$fields2;
                constraints = fields.reduce(function (rules, field) {
                  return Object.assign({}, rules, _defineProperty({}, field.key, prepConstraintsForValidate(field.constraints)));
                }, {});
                validationErrors = keys(payload_).reduce(function (errors_, attr) {
                  var error_ = validate.single(payload_[attr], constraints[attr]);

                  if (error_) {
                    return Object.assign({}, errors_, _defineProperty({}, attr, error_));
                  }

                  return errors_;
                }, {});
                fieldKeys = fields.map(function (field) {
                  return field.key;
                });
                pickFields = pick(fieldKeys);

                if (!keys(validationErrors).length) {
                  _context33.next = 15;
                  break;
                }

                return _context33.abrupt("return", Promise.reject(validationErrors));

              case 15:
                if (typeof payload_ === 'object') {
                  payload_ = Object.assign({}, pickFields(payload_), {
                    '__meta__/lastModifiedBy': _get(authService_, 'currentUser.uid', 'UNKNOWN'),
                    '__meta__/lastModifiedDate': new Date().toISOString(),
                    id: isSingleType ? contentRef : entryRef
                  });
                }

                if (!isSingleType) {
                  _context33.next = 18;
                  break;
                }

                return _context33.abrupt("return", contentAPI.ref(contentRef).update(payload_));

              case 18:
                return _context33.abrupt("return", contentAPI.ref([contentRef, entryRef]).update(payload_));

              case 19:
              case "end":
                return _context33.stop();
            }
          }
        }, _callee33);
      }));

      function update(_x27, _x28, _x29) {
        return _update.apply(this, arguments);
      }

      return update;
    }(),

    /**
     * The simplest way to delete data for a given reference.
     *
     * @param {String} contentRef
     * @param {String} entryRef
     * @returns {Promise}
     */
    remove: function remove(contentRef, entryRef) {
      if (typeof entryRef === 'number') {
        entryRef = entryRef.toString();
      }

      if (typeof contentRef !== 'string' || typeof entryRef !== 'string') {
        throw error('"remove" called with the incorrect arguments. Check the docs for details.');
      }

      return contentAPI.ref([contentRef, entryRef]).remove();
    },

    /**
     * Transactional operation
     * https://firebase.google.com/docs/reference/js/firebase.database.Reference#transaction
     *
     * @param {String} contentRef
     * @param {String} entryRef
     * @param {Function} updateFn
     * @param {Function} [cb=() => {}]
     * @returns
     */
    transaction: function transaction(contentRef, entryRef, updateFn) {
      var cb = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};

      if (typeof entryRef === 'number') {
        entryRef = entryRef.toString();
      }

      if (typeof contentRef !== 'string' || typeof entryRef !== 'string' || typeof updateFn !== 'function') {
        throw error('"transaction" called with the incorrect arguments. Check the docs for details.');
      }

      return contentAPI.ref([contentRef, entryRef]).transaction(updateFn, cb);
    }
  };
  var navigationAPI = {
    /**
     * Establish and return a reference to section in firebase db
     *
     * @param {String} ref
     * @returns {Object} Ref object
     */
    ref: function ref(_ref15) {
      if (!databaseService_) {
        throw error('The Database service is not available. Make sure the "databaseURL" property is provided.');
      }

      return databaseService_.ref(getNavigationRefPath(_ref15, env_, locale_));
    },

    /**
     * @description Get snapshot for given navigation ID/reference
     * @param {String} navRef
     * @param {Object} [options={}]
     * @returns {Promise} Resolves to snapshot of query
     */
    getRaw: function getRaw(navRef) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var ref = typeof navRef === 'string' ? navRef : null;
      var opts = typeof navRef === 'string' ? options : navRef || {};
      var ordered = applyOrderBy(navigationAPI.ref(ref), opts);
      var filtered = applyFilters(ordered, opts);
      return filtered.once(opts.event || 'value');
    },

    /**
     * @description Get navigation object for given navigation ID/reference
     * @param {String} [navRef]
     * @param {Object} [options={}]
     * @returns {Promise} Resolves to value of query
     */
    get: function () {
      var _get6 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee34(navRef) {
        var options,
            _snapshot5,
            wrappedNav,
            nav,
            opts,
            snapshot,
            withLocales,
            currentLocale,
            withoutLocales,
            pluckedMenus,
            _args34 = arguments;

        return _regeneratorRuntime.wrap(function _callee34$(_context34) {
          while (1) {
            switch (_context34.prev = _context34.next) {
              case 0:
                options = _args34.length > 1 && _args34[1] !== undefined ? _args34[1] : {};

                if (!(typeof navRef === 'string')) {
                  _context34.next = 12;
                  break;
                }

                _context34.next = 4;
                return navigationAPI.getRaw(navRef, options);

              case 4:
                _snapshot5 = _context34.sent;
                _context34.next = 7;
                return pluckResultFields(options.fields, _defineProperty({}, navRef, _snapshot5.val()));

              case 7:
                wrappedNav = _context34.sent;
                nav = wrappedNav[navRef]; // Only try and structure items if items weren't plucked out

                if (!(nav && nav.hasOwnProperty('items'))) {
                  _context34.next = 11;
                  break;
                }

                return _context34.abrupt("return", Object.assign({}, nav, {
                  items: formatStructure(options.structure, {
                    idProperty: 'uuid',
                    parentProperty: 'parentIndex'
                  }, nav.items)
                }));

              case 11:
                return _context34.abrupt("return", nav);

              case 12:
                // All menus
                opts = navRef || {};
                _context34.next = 15;
                return navigationAPI.getRaw(opts);

              case 15:
                snapshot = _context34.sent;
                withLocales = snapshot.val();
                currentLocale = locale_; // TODO: Look at getting from API method

                withoutLocales = keys(withLocales).reduce(function (menus, key) {
                  return Object.assign({}, menus, _defineProperty({}, key, withLocales[key][currentLocale]));
                }, {});
                _context34.next = 21;
                return pluckResultFields(opts.fields, withoutLocales);

              case 21:
                pluckedMenus = _context34.sent;
                return _context34.abrupt("return", keys(pluckedMenus).reduce(function (menus, key) {
                  var nav = pluckedMenus[key]; // Only try and structure items if items weren't plucked out

                  if (nav && nav.hasOwnProperty('items')) {
                    var structuredNav = Object.assign({}, nav, {
                      items: formatStructure(opts.structure, {
                        idProperty: 'uuid',
                        parentProperty: 'parentIndex'
                      }, nav.items)
                    });
                    return Object.assign({}, menus, _defineProperty({}, key, structuredNav));
                  }

                  return Object.assign({}, menus, _defineProperty({}, key, nav));
                }, {}));

              case 23:
              case "end":
                return _context34.stop();
            }
          }
        }, _callee34);
      }));

      function get(_x30) {
        return _get6.apply(this, arguments);
      }

      return get;
    }(),

    /**
     * Read value once from db and return raw snapshot
     *
     * @param {String} navRef
     * @param {Object} [options={}]
     * @returns {Promise} Resolves to snapshot of query
     */
    getItemsRaw: function getItemsRaw(navRef) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!navRef) {
        throw error('"getItemsRaw" method requires a navigation reference');
      }

      var ordered = applyOrderBy(navigationAPI.ref(navRef).child('items'), options);
      var filtered = applyFilters(ordered, options);
      return filtered.once(options.event || 'value');
    },

    /**
     * Read value once from db
     *
     * @param {String} navRef
     * @param {Object} [options={}]
     * @returns {Promise} Resolves to value of query
     */
    getItems: function () {
      var _getItems = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee35(navRef) {
        var options,
            pluckFields,
            structureItems,
            snapshot,
            _args35 = arguments;
        return _regeneratorRuntime.wrap(function _callee35$(_context35) {
          while (1) {
            switch (_context35.prev = _context35.next) {
              case 0:
                options = _args35.length > 1 && _args35[1] !== undefined ? _args35[1] : {};

                if (navRef) {
                  _context35.next = 3;
                  break;
                }

                throw error('"getItems" method requires a navigation reference');

              case 3:
                pluckFields = pluckResultFields(options.fields);
                structureItems = formatStructure(options.structure, {
                  idProperty: 'uuid',
                  parentProperty: 'parentIndex'
                });
                _context35.next = 7;
                return navigationAPI.getItemsRaw(navRef, options);

              case 7:
                snapshot = _context35.sent;
                return _context35.abrupt("return", compose(pluckFields, structureItems)(snapshot.val()));

              case 9:
              case "end":
                return _context35.stop();
            }
          }
        }, _callee35);
      }));

      function getItems(_x31) {
        return _getItems.apply(this, arguments);
      }

      return getItems;
    }(),

    /**
     * @description Establish stream to read value consistently from db, returning the raw snapshot
     * @param {String} [navRef]
     * @param {Object} [options={}]
     * @param {Function} cb
     * @returns {Promise} Resolves to snapshot of query
     */
    subscribeRaw: function subscribeRaw(navRef) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var cb = arguments.length > 2 ? arguments[2] : undefined;

      // Single menu
      if (typeof navRef === 'string') {
        if (!cb) {
          cb = options; // second param is then the callback

          options = {}; // set default options
        }

        var _ordered5 = applyOrderBy(navigationAPI.ref(navRef), options);

        var _filtered5 = applyFilters(_ordered5, options);

        return _filtered5.on(options.event || 'value', cb);
      } // All menus


      cb = options;
      options = navRef;

      if (typeof cb === 'object') {
        cb = navRef; // first param is then the callback

        options = {}; // set default options
      }

      var ordered = applyOrderBy(navigationAPI.ref(null), options);
      var filtered = applyFilters(ordered, options);
      return filtered.on(options.event || 'value', cb);
    },

    /**
     * @description Establish stream to read value consistently from db, returning the processed value
     * @param {String} [navRef]
     * @param {Object} [options={}]
     * @param {Function} cb
     * @returns {Promise} Resolves to value of query
     */
    subscribe: function subscribe(navRef) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var cb = arguments.length > 2 ? arguments[2] : undefined;

      try {
        // Single Menu
        if (typeof navRef === 'string') {
          if (!cb || typeof options === 'function') {
            cb = options; // second param is then the callback

            options = {}; // set default options
          }

          var _pluckFields7 = pluckResultFields(options.fields);

          return navigationAPI.subscribeRaw(navRef, options,
          /*#__PURE__*/
          function () {
            var _ref16 = _asyncToGenerator(
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee36(snapshot) {
              var wrappedNav, nav;
              return _regeneratorRuntime.wrap(function _callee36$(_context36) {
                while (1) {
                  switch (_context36.prev = _context36.next) {
                    case 0:
                      _context36.next = 2;
                      return compose(_pluckFields7)(_defineProperty({}, navRef, snapshot.val()));

                    case 2:
                      wrappedNav = _context36.sent;
                      nav = wrappedNav[navRef]; // Only try and structure items if items weren't plucked out

                      if (nav && nav.hasOwnProperty('items')) {
                        nav.items = formatStructure(options.structure, {
                          idProperty: 'uuid',
                          parentProperty: 'parentIndex'
                        }, nav.items);
                      }

                      return _context36.abrupt("return", cb(null, nav));

                    case 6:
                    case "end":
                      return _context36.stop();
                  }
                }
              }, _callee36);
            }));

            return function (_x32) {
              return _ref16.apply(this, arguments);
            };
          }());
        } // All menus


        cb = options;
        options = navRef;

        if (typeof cb === 'object') {
          cb = navRef; // first param is then the callback

          options = {}; // set default options
        }

        var pluckFields = pluckResultFields(options.fields);
        return navigationAPI.subscribeRaw(options,
        /*#__PURE__*/
        function () {
          var _ref17 = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee37(snapshot) {
            var withLocales, currentLocale, withoutLocales, pluckedMenus, result;
            return _regeneratorRuntime.wrap(function _callee37$(_context37) {
              while (1) {
                switch (_context37.prev = _context37.next) {
                  case 0:
                    withLocales = snapshot.val();
                    currentLocale = locale_; // TODO: Look at getting from API method

                    withoutLocales = keys(withLocales).reduce(function (menus, key) {
                      return Object.assign({}, menus, _defineProperty({}, key, withLocales[key][currentLocale]));
                    }, {});
                    _context37.next = 5;
                    return compose(pluckFields)(withoutLocales);

                  case 5:
                    pluckedMenus = _context37.sent;
                    result = keys(pluckedMenus).reduce(function (menus, key) {
                      var nav = pluckedMenus[key]; // Only try and structure items if items weren't plucked out

                      if (nav && nav.hasOwnProperty('items')) {
                        var structuredNav = Object.assign({}, nav, {
                          items: formatStructure(options.structure, {
                            idProperty: 'uuid',
                            parentProperty: 'parentIndex'
                          }, nav.items)
                        });
                        return Object.assign({}, menus, _defineProperty({}, key, structuredNav));
                      }

                      return Object.assign({}, menus, _defineProperty({}, key, nav));
                    }, {});
                    cb(null, result); // Error-first callback

                  case 8:
                  case "end":
                    return _context37.stop();
                }
              }
            }, _callee37);
          }));

          return function (_x33) {
            return _ref17.apply(this, arguments);
          };
        }());
      } catch (err) {
        return cb(err);
      }
    },

    /**
     * @description Detach listeners from given reference.
     * @param {String} navRef
     * @param {String} event
     * @returns {Promise}
     */
    unsubscribe: function unsubscribe() {
      if (arguments.length === 2) {
        // Is second arg a valid firebase child event?
        if (ALLOWED_CHILD_EVENTS.includes(arguments.length <= 1 ? undefined : arguments[1])) {
          // args[0] = navRef
          // args[1] = event
          return navigationAPI.ref(arguments.length <= 0 ? undefined : arguments[0]).off(arguments.length <= 1 ? undefined : arguments[1]);
        }

        throw error("\"".concat(arguments.length <= 1 ? undefined : arguments[1], "\" is not a valid child event"));
      }

      if (arguments.length === 1) {
        return navigationAPI.ref(arguments.length <= 0 ? undefined : arguments[0]).off();
      }

      throw error('"unsubscribe" method needs to be called with min 1 argument and max 2 arguments');
    },

    /**
     * Save data for a specific navigation entry/menu.
     * This overwrites data at the specified location, including any child nodes.
     *
     * @param {String} navRef
     * @param {Object} payload
     * @returns {Promise}
     */
    set: function set(navRef, payload) {
      if (typeof navRef !== 'string' || typeof payload !== 'object' && payload !== null) {
        throw error('"set" called with the incorrect arguments. Check the docs for details.');
      }

      var payload_ = typeof payload === 'object' ? Object.assign({}, payload, {
        __meta__: {
          createdBy: _get(authService_, 'currentUser.uid', 'UNKNOWN'),
          createdDate: new Date().toISOString()
        },
        id: navRef
      }) : payload;
      return navigationAPI.ref(navRef).set(payload_);
    },

    /**
     * Simultaneously write to specific children of a node without overwriting other child nodes.
     *
     * @param {String} navRef
     * @param {Object} payload
     * @returns {Promise}
     */
    update: function update(navRef, payload) {
      if (typeof navRef !== 'string' || typeof payload !== 'object' && payload !== null) {
        throw error('"update" called with the incorrect arguments. Check the docs for details.');
      }

      var payload_ = typeof payload === 'object' ? Object.assign({}, payload, {
        '__meta__/lastModifiedBy': _get(authService_, 'currentUser.uid', 'UNKNOWN'),
        '__meta__/lastModifiedDate': new Date().toISOString(),
        id: navRef
      }) : payload;
      return navigationAPI.ref(navRef).update(payload_);
    },

    /**
     * The simplest way to delete data for a given reference.
     *
     * @param {String} navRef
     * @returns {Promise}
     */
    remove: function remove(navRef) {
      if (typeof navRef !== 'string') {
        throw error('"remove" called with the incorrect arguments. Check the docs for details.');
      }

      return navigationAPI.ref(navRef).remove();
    },

    /**
     * Transactional operation
     * https://firebase.google.com/docs/reference/js/firebase.database.Reference#transaction
     *
     * @param {String} navRef
     * @param {Function} updateFn
     * @param {Function} [cb=() => {}]
     * @returns
     */
    transaction: function transaction(navRef, updateFn) {
      var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

      if (typeof navRef !== 'string' || typeof updateFn !== 'function') {
        throw error('"transaction" called with the incorrect arguments. Check the docs for details.');
      }

      return navigationAPI.ref(navRef).transaction(updateFn, cb);
    }
  }; // Setup listener to get app schemas and cache it

  var start = function start() {
    schemasAPI.subscribe(null, function (err, schemas) {
      if (err) {
        return console.error(err);
      }

      return set(CACHE, "schemas[".concat(env_, "]"), schemas);
    });
  };

  start(); // Public API

  return {
    name: firebaseApp_.name,
    firebaseApp: firebaseApp_,
    databaseService: databaseService_,
    storageService: storageService_,
    authService: authService_,
    firestoreService: firestoreService_,

    /**
     * Sets the locale to be used for the flamelink app
     *
     * @param {String} locale The locale to set
     * @returns {Promise} Resolves to given locale if it is a supported locale, otherwise it rejects
     * @deprecated
     */
    setLocale: function setLocale() {
      var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : locale_;
      deprecate('app.setLocale()', 'Use the "app.settings.setLocale()" method instead.');
      return new Promise(function (resolve, reject) {
        databaseService_.ref('/flamelink/settings/locales').once('value').then(function (snapshot) {
          var supportedLocales_ = snapshot.val();

          if (!supportedLocales_) {
            return reject(error('No supported locales found.'));
          }

          if (!supportedLocales_.includes(locale)) {
            return reject(error("\"".concat(locale, "\" is not a supported locale. Supported Locales: ").concat(supportedLocales_.join(', '))));
          }

          locale_ = locale;
          return resolve(locale_);
        }).catch(reject);
      });
    },

    /**
     * Sets the environment to be used for the flamelink app
     *
     * @param {String} env The environment to set
     * @returns {Promise} Resolves to given environment if it is a supported environment, otherwise it rejects
     * @deprecated
     */
    setEnv: function setEnv() {
      var env = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : env_;
      deprecate('app.setEnv()', 'Use the "app.settings.setEnv()" method instead.');
      return new Promise(function (resolve, reject) {
        databaseService_.ref('/flamelink/settings/environments').once('value').then(function (snapshot) {
          var supportedEnvironments_ = snapshot.val();

          if (!supportedEnvironments_) {
            return reject(error("No supported environments found."));
          }

          if (!supportedEnvironments_.includes(env)) {
            return reject(error("\"".concat(env, "\" is not a supported environment. Supported Environments: ").concat(supportedEnvironments_.join(', '))));
          }

          env_ = env;
          return resolve(env_);
        }).catch(reject);
      });
    },

    /**
     * Returns the set locale for the flamelink app
     *
     * @returns {Promise} Resolves with locale (just using promise for consistency and allowing us to make this async in the future)
     * @deprecated
     */
    getLocale: function getLocale() {
      deprecate('app.getLocale()', 'Use the "app.settings.getLocale()" method instead.');
      return Promise.resolve(locale_);
    },

    /**
     * Returns the set environment for the flamelink app
     *
     * @returns {Promise} Resolves with environment (just using promise for consistency and allowing us to make this async in the future)
     * @deprecated
     */
    getEnv: function getEnv() {
      deprecate('app.getEnv()', 'Use the "app.settings.getEnv()" method instead.');
      return Promise.resolve(env_);
    },
    content: contentAPI,
    nav: navigationAPI,
    schemas: schemasAPI,
    storage: storageAPI,
    settings: settingsAPI
  };
}

flamelink.VERSION = '0.19.12';
export default flamelink;